import { VidyardHelpVideo } from './vidyard.repository';
import { actionsFactory, props } from '@ngneat/effects';

const vidyardActions = actionsFactory('vidyard');

export const setCurrentHelpVideo = vidyardActions.create(
  'Set Current Help Video',
  props<{ video: VidyardHelpVideo }>()
);
